// This file is auto-generated using the 'icon-generator' package.
// Any changes made to this file manually will be lost the next time the
// file is generated

import * as React from "react";
import { MappedProps, PassedProps, useMappedProps } from "./useMappedProps";

const Icon: React.ComponentType<
  Omit<React.SVGProps<SVGSVGElement>, keyof MappedProps> & PassedProps
> = (passedProps) => {
  const props = useMappedProps(passedProps);
  return (
    <svg
      id="RPlusVIcon__Ebene_2"
      data-name="Ebene 2"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 341.1 240"
      {...props}
    >
      <defs>
        <style>{".RPlusVIcon__cls-1{fill:#001957}"}</style>
      </defs>
      <path
        className="RPlusVIcon__cls-1"
        d="M277.67 80h-27.16l-26.78 39.94V80h-25.81v31.3h-18.34V90.14h-18v21.15H143.1a21.65 21.65 0 0 0 2.22-9.57c0-12-10.72-21.72-22.71-21.73H80v80h25.74v-59.54h5.13a9.78 9.78 0 1 1 0 19.55l16.29 40h27.38l-12.84-31h19.86v21.16h18V129h18.34v31h25.81Z"
      />
    </svg>
  );
};

const RPlusVIcon = Icon;
export default RPlusVIcon;
